// extracted by mini-css-extract-plugin
export default {"dialog":"InviteDialog_dialog__1CKAv","field":"InviteDialog_field__gZRjM","input":"InviteDialog_input__YdXhT","copy":"InviteDialog_copy__OK4vb","copied":"InviteDialog_copied__x4wcJ"};